import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentFeatures } from '@era/app';
import { Device, DeviceType } from '@era/locations-sdk';
import { DeviceStoreSelectors, LocationSubset } from '@era/stores';
import { EnvironmentService } from '@methylium/core';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ContextMenuComponent } from '@rocksoft/cdk';
import { Observable } from 'rxjs';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DeviceGridComponent } from '../device-grid/device-grid.component';

@Component({
  selector: 'era-devices-kiosk',
  templateUrl: './devices-kiosk.container.html',
  styleUrls: ['./devices-kiosk.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DeviceGridComponent, ContextMenuComponent, NgbDropdownButtonItem, NgbDropdownItem, AsyncPipe],
})
export class DevicesKioskContainerComponent {
  public readonly features: EnvironmentFeatures;
  public readonly kioskDevices$: Observable<Device[]>;
  public readonly kioskDevicesCount$: Observable<number>;

  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly environmentService: EnvironmentService,
    private readonly modalService: NgbModal
  ) {
    this.features = this.environmentService.environment.features;
    this.kioskDevices$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationKioskDevices);

    this.kioskDevicesCount$ = this.deviceStore.select(DeviceStoreSelectors.selectCurrentLocationKioskDevicesCount);
  }

  public itemSelected(device: Device) {
    if (device.deviceType === DeviceType.Apple) {
      void this.router.navigate(['apple', device.deviceId], { relativeTo: this.route });
    }
  }

  public openRebootRequest() {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.Kiosk;
  }
}
